import React from 'react';

interface StatusPagesIconProps {
    isActive?: boolean;
    width?: number;
    height?: number;
}

const StatusPagesIcon: React.FC<StatusPagesIconProps> = ({ isActive = false, width = 16, height = 16 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect
                x="1.3335"
                y="2.66699"
                width="13.3333"
                height="10.6667"
                rx="2"
                stroke="currentColor"
                fill={isActive ? 'currentColor' : 'none'}
            />
            <path
                d="M1.3335 5.33301H14.6668"
                stroke={isActive ? 'white' : 'currentColor'}
                strokeLinecap="round"
            />
            <path
                d="M4 8.66699H7.33333"
                stroke={isActive ? 'white' : 'currentColor'}
                strokeLinecap="round"
            />
            <path
                d="M4 10.667H9.33333"
                stroke={isActive ? 'white' : 'currentColor'}
                strokeLinecap="round"
            />
            <circle
                cx="11.3332"
                cy="9.33301"
                r="1.33333"
                fill={isActive ? 'white' : 'currentColor'}
            />
        </svg>
    );
};

export default StatusPagesIcon;
